<div class="uk-card uk-card-default" style="margin: 0 1rem 1rem 0"  *ngIf="margeData">
  <div class="uk-card-header uk-padding-small" [ngClass]="[headerBackground]">
    <div class="uk-grid-small uk-flex-middle uk-grid">
      <div class="uk-width-expand uk-width-5-6">
        <h3 class="uk-card-title uk-margin-remove-bottom primary-color " [ngClass]="[headerColor]">
          Marge
        </h3>
      </div>
      <div class="info primary-color uk-width-1-6 k-text-right">
        <i
          class="k-icon k-i-info"
          uk-tooltip="Il s’agit du chiffre d’affaires des sessions en fonction des filtres appliqués. Il est indiqué sous forme de montant cumulé ou de moyenne par stagiaire.</br>
                   Notez que le statut des sessions évoluant dans le temps, les données peuvent varier en fonction du moment de la consultation de l’indicateur.</br>
                   Notez également que les données sont calculées au prorata des dates de formation incluses dans la période filtrée.</br>
                   Masquez/affichez cet indicateur sur l’extranet du client à l’aide du switch situé en haut à droite de la tuile."
        ></i>
      </div>
    </div>
  </div>
  <div class="uk-card-body uk-padding-small">
    <p class="stats-sub-title margin-left-12">Marge brute</p>
    <p class="margin-left-12">
      <span class="stats-number-before"> {{ margeData.marge | number: '0.0':'fr' }}</span>
    </p>

    <p class="stats-sub-title margin-left-12">Taux de marge</p>
    <div *ngIf="margeData.marge > 0">
      <p class="stats-number-before margin-left-12">{{ margeData.pourcentCA }}%</p>
      <ags-kendo-progress-bar
        [height]="7"
        [style.width.%]="80"
        [type]="'value'"
        [value]="margeData.pourcentCA"
        [max]="100"
        [min]="0"
      ></ags-kendo-progress-bar>
    </div>
    <div *ngIf="!margeData.pourcentCA || margeData.pourcentCA < 0">
      <br />
      <p class="margin-left-12"><span class="no-data">Donnée indisponible</span></p>
      <div>
        <ags-kendo-progress-bar
          [height]="7"
          [style.width.%]="80"
          [value]="0"
          [max]="100"
          [min]="0"
          [progressColor]="'#2CBB9D'"
        ></ags-kendo-progress-bar>
      </div>
    </div>
    <br />
  </div>
</div>
